import { useMemo } from "react";

import { range } from "~/tools/range";
import { round } from "~/tools/round";
import { shuffle } from "~/tools/shuffle";

const PERCENTAGES = range(0, 99);

export function usePseudoRandomIntGenerator({
	min,
	max,
	step,
}: {
	min: number;
	max: number;
	step: number;
}): (index: number) => number {
	return useMemo(() => {
		const sequence = shuffle(PERCENTAGES);

		return (index: number) => {
			const percent = sequence[index % sequence.length] / 100;

			const value = min + (max - min) * percent;

			return round(value / step, 0) * step;
		};
	}, [min, max, step]);
}
